module.exports = __webpack_public_path__ + "static/media/lion-walking.d7154a90.png";